/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vtp_Shipments_Status_OverdueInputs */

const vi_vtp_shipments_status_overdue = /** @type {(inputs: Vtp_Shipments_Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quá hạn giao`)
};

/**

* @param {Vtp_Shipments_Status_OverdueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vtp_shipments_status_overdue = /** @type {((inputs?: Vtp_Shipments_Status_OverdueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vtp_Shipments_Status_OverdueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vtp_shipments_status_overdue(inputs)
});